import React, { useState, useEffect, useMemo } from "react";
import Paragraph from "../../ExternalCom/Paragraph/Paragraph";
import Heading from "../../ExternalCom/Heading/Headingcom";
import Images4 from "../../Images/newimg4.png";
import Images5 from "../../Images/newimg5.png";
import newimg12 from "../../Images/newimg12.jpeg"; // ProPalz
import newimg13 from "../../Images/newimg13.jpeg"; // myHRdept

const Products = () => {
  const [activeTab, setActiveTab] = useState("company");
  const [expandedPackage, setExpandedPackage] = useState(null);
  const [activeBenefitIndex, setActiveBenefitIndex] = useState(0);
  const [typingText, setTypingText] = useState("");

  const packages = [
    {
      id: 1,
      name: "The First 100 Days",
      subtitle: "Foundation Setup",
      ideal: "5–30 employees",
      description: "For early-stage teams that have zero HR structure.",
      problems: [
        "No policies, no handbook, no clarity in roles",
        "Ad hoc onboarding",
        "Confusion on leave, attendance, work norms",
        "No HR documentation",
        "Founders doing HR themselves",
      ],
      deliverables: [
        {
          title: "HR Policy Starter Pack",
          items: [
            "Leave policy",
            "Attendance/timings",
            "Work-from-home norms",
            "Salary confidentiality",
            "POSH policy",
            "Probation & confirmation policy",
            "Exit policy",
            "Basic employee handbook",
          ],
        },
        {
          title: "Onboarding & Offboarding Systems",
          items: [
            "Offer letter kit",
            "Joining kit",
            "Employee master database",
            "Asset log",
            "Simple offboarding checklist",
          ],
        },
        {
          title: "HR Operations Setup",
          items: [
            "Templates library",
            "Employee documentation structure",
            "Ticketing system for employee requests",
          ],
        },
        {
          title: "Founder Support & Fixes",
          items: ["Weekly calls", "Real-time HR advisory", "Red-flag clean-up"],
        },
      ],
      outcome:
        "A clean, compliant, structured HR foundation that stops fire-fighting and gives clarity to the team.",
    },
    {
      id: 2,
      name: "People Ops Growth Kit",
      subtitle: "Systems for Scaling",
      ideal: "30–100 employees",
      description:
        "For companies moving from 30 to 100 employees and feeling the growth pain.",
      problems: [
        "Random salary increases",
        "No performance structure",
        "Managers struggling to run teams",
        "Culture becoming fragile",
        "Lack of process discipline",
        "Zero HR tech adoption",
      ],
      deliverables: [
        {
          title: "Performance & Role Clarity Systems",
          items: [
            "JD refresh & role clarity",
            "KRA/KPI framework",
            "Quarterly review system",
            "Goal-setting templates",
            "Performance documentation",
          ],
        },
        {
          title: "HR Technology Setup",
          items: [
            "HRMS selection support",
            "Implementation support",
            "Leave, attendance, onboarding automation",
            "Employee workflows",
          ],
        },
        {
          title: "Culture & Team Health",
          items: [
            "1:1 playbook for managers",
            "Culture code creation",
            "Values implementation",
            "Engagement calendar",
            "Feedback loops",
            "Listening surveys",
          ],
        },
        {
          title: "People Ops Automation",
          items: [
            "Onboarding flows",
            "Document automation",
            "Employee database",
            "Task/workflow automation",
          ],
        },
      ],
      outcome:
        "The company starts behaving like a mature team without adding headcount. Managers get empowered, and founders stop fighting operational fires.",
    },
    {
      id: 3,
      name: "HR Partner for Scaling SMEs",
      subtitle: "Strategic HR Leadership",
      ideal: "100–250 employees",
      description: "For companies that need a Head of HR without hiring one.",
      problems: [
        "Zero leadership bandwidth",
        "Inconsistent performance culture",
        "Managers not fully trained",
        "Employee escalations",
        "Drop in accountability",
        "Lack of HR strategy or planning",
      ],
      deliverables: [
        {
          title: "HR Strategy & Annual Roadmap",
          items: [
            "Org structure plan",
            "Workforce planning",
            "Skills development roadmap",
            "Career pathing",
            "Succession planning",
          ],
        },
        {
          title: "Leadership & Manager Enablement",
          items: [
            "Manager training",
            "Coaching on feedback",
            "Escalation handling",
            "Building leadership discipline",
          ],
        },
        {
          title: "HR Governance",
          items: [
            "Monthly HR scorecard",
            "Policy strengthening",
            "Audit & compliance checks",
            "Risk reduction",
          ],
        },
        {
          title: "Scaling Culture & Retention",
          items: [
            "Retention strategy",
            "Rewards & recognition system",
            "Engagement audits",
            "Fixing team friction",
            "Exit analytics & prevention",
          ],
        },
      ],
      outcome:
        "A stable, scalable people system where the company can grow without losing culture, quality or speed.",
    },
    {
      id: 4,
      name: "HR Tech + Ops PRO",
      subtitle: "Full HR Department Outsourced",
      ideal: "All sizes",
      description:
        "For startups that want end-to-end HR operations fully managed.",
      problems: [],
      deliverables: [
        {
          title: "Complete HR Management",
          items: [
            "All policies",
            "All HR operations",
            "HRMS management",
            "Employee lifecycle management",
            "Performance reviews",
            "Founder & manager support",
            "Employee relations handling",
            "Full documentation management",
            "HR dashboards & analytics",
            "Helpdesk support",
          ],
        },
      ],
      outcome:
        "You operate like a company with a complete HR department, at a fraction of the cost.",
    },
    {
      id: 5,
      name: "The Compliance Shield",
      subtitle: "Addon Package",
      ideal: "All sizes",
      description: "For companies afraid of legal trouble or audits.",
      problems: [],
      deliverables: [
        {
          title: "Legal & Compliance Protection",
          items: [
            "POSH committee setup",
            "HR policies",
            "Documentation audit",
            "Employee file audit",
            "Contract templates",
            "Warning & disciplinary framework",
            "HR risk assessment",
          ],
        },
      ],
      outcome:
        "Founders sleep peacefully knowing everything is clean, safe and audit-ready.",
    },
  ];

  const benefits = useMemo(
    () => [
      "Practical, not theoretical",
      "Solves real pain points most founders face",
      "Helps them scale without chaos",
      "Gives structure without hiring full-time HR",
      "Every package is a retainer, predictable and manageable",
      "Immediate wins + long-term systems",
    ],
    [],
  );

  useEffect(() => {
    if (activeTab !== "services") return;

    let charIndex = 0;
    setTypingText("");

    const currentBenefit = benefits[activeBenefitIndex];
    if (!currentBenefit) return;

    const typingInterval = setInterval(() => {
      if (charIndex <= currentBenefit.length) {
        setTypingText(currentBenefit.substring(0, charIndex));
        charIndex++;
      } else {
        clearInterval(typingInterval);

        // Move to next benefit after pause
        setTimeout(() => {
          setActiveBenefitIndex((prev) =>
            prev + 1 < benefits.length ? prev + 1 : 0,
          );
        }, 1200);
      }
    }, 30);

    return () => clearInterval(typingInterval);
  }, [activeTab, activeBenefitIndex, benefits]);

  const togglePackage = (id) => {
    setExpandedPackage(expandedPackage === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Navigation Tabs */}
      <div className="sticky top-0 bg-white shadow-md z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8 border-b">
            <button
              onClick={() => setActiveTab("company")}
              className={`py-2 px-4 text-lg font-semibold transition-all
    bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent
    outline-none focus:outline-none focus-visible:outline-none
    ${
      activeTab === "company"
        ? "border-b-4 border-blue-500 text-blue-600"
        : "text-gray-600 hover:text-blue-500"
    }`}
            >
              Company
            </button>

            <button
              onClick={() => setActiveTab("products")}
              className={`py-2 px-4 text-lg font-semibold transition-all
    bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent
    outline-none focus:outline-none focus-visible:outline-none
    ${
      activeTab === "products"
        ? "border-b-4 border-blue-500 text-blue-600"
        : "text-gray-600 hover:text-blue-500"
    }`}
            >
              Products
            </button>

            <button
              onClick={() => setActiveTab("services")}
              className={`py-2 px-4 text-lg font-semibold transition-all
    bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent
    outline-none focus:outline-none focus-visible:outline-none
    ${
      activeTab === "services"
        ? "border-b-4 border-blue-500 text-blue-600"
        : "text-gray-600 hover:text-blue-500"
    }`}
            >
              Services
            </button>
          </div>
        </div>
      </div>

      {/* Products Section */}
      {activeTab === "products" && (
        <div className="max-w-7xl mx-auto sm:p-6 lg:p-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Our Products
          </h1>

          {/* Product 1: myHRdept.in */}
          <div className="mb-10 bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow">
            <div className="grid md:grid-cols-2 gap-8 p-5 md:p-9">
              <div className="flex items-center justify-centerrounded-xl">
                <img
                  src={newimg13}
                  alt="myHRdept"
                  className="w-full max-h-72 object-contain rounded-lg"
                />
              </div>

              <div className="flex flex-col justify-center">
                <h2 className="text-4xl font-bold mb-6">
                  my<span className="text-blue-600">HR</span>dept.in
                </h2>
                <a
                  href="https://myhrdept.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-700 text-lg font-semibold mb-6 inline-block"
                >
                  Visit myhrdept.in →
                </a>
                <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
                  <p className="flex items-start">
                    <span className="text-blue-600 mr-2 mt-1">•</span>
                    <span>
                      At myhrdept.in we understand the unique challenges of
                      modern HR management.
                    </span>
                  </p>
                  <p className="flex items-start">
                    <span className="text-blue-600 mr-2 mt-1">•</span>
                    <span>
                      That's why we're committed to providing you with a
                      user-friendly, feature-rich platform that empowers you to
                      focus on what matters most – your people.
                    </span>
                  </p>
                  <p className="flex items-start">
                    <span className="text-blue-600 mr-2 mt-1">•</span>
                    <span>
                      Experience the future of HR management with myhrdept.in
                      today.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Product 2: ProPalz.com */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow">
            <div className="grid md:grid-cols-2 gap-8 p-5 md:p-9">
              <div className="flex flex-col justify-center order-2 md:order-1">
                <h2 className="text-4xl font-bold mb-6">
                  Pro<span className="text-teal-500">Palz</span>.com
                </h2>
                <a
                  href="https://ProPalz.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-700 text-lg font-semibold mb-6 inline-block"
                >
                  Visit ProPalz.in →
                </a>
                <p className="flex items-start text-gray-700 text-lg leading-relaxed">
                  <span className="text-teal-500 mr-2 mt-1">•</span>
                  <span>
                    Your Ultimate Socializing and Professional Networking
                    Platform
                  </span>
                </p>
              </div>
              <div className="flex items-center justify-centerrounded-xl order-1 md:order-2">
                <div className="flex items-center justify-center rounded-xl order-1 md:order-2">
                  <img
                    src={newimg12}
                    alt="ProPalz"
                    className="w-full max-h-72 object-contain rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Services Section */}
      {activeTab === "services" && (
        <div className="max-w-7xl mx-auto sm:p-6 lg:p-8">
          <div className="mb-8">
            <div className="grid md:grid-cols-[30%_70%] gap-8 items-start px-6">
              {/* Left column (30%) */}
              <div className="p-2">
                <h1 className="text-2xl font-bold text-gray-800 mb-6">
                  HRLabs – HR Services Stack
                </h1>
                <p className="text-base text-gray-600">
                  Built for lean teams that want to scale without chaos
                </p>
              </div>

              {/* Right column (70%) */}
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-6 text-white">
                <h3 className="text-lg font-semibold mb-3">
                  Why This Stack Works for MSMEs & Startups
                </h3>

                <div className="flex items-start space-x-3">
                  <svg
                    className="w-6 h-6 text-green-300 flex-shrink-0 mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>

                  <span className="text-base font-medium">
                    {typingText}
                    {typingText.length <
                      benefits[activeBenefitIndex]?.length && (
                      <span className="inline-block w-0.5 h-4 bg-white ml-1 animate-pulse" />
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Service Packages */}
          <div className="space-y-6">
            {packages.map((pkg) => (
              <div
                key={pkg.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all"
              >
                <button
                  onClick={() => togglePackage(pkg.id)}
                  className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xl">
                      {pkg.id}
                    </div>
                    <div className="text-left">
                      <h3 className="text-2xl font-bold text-gray-800">
                        {pkg.name}
                      </h3>
                      <p className="text-base text-gray-600">{pkg.subtitle}</p>
                      <span className="inline-block mt-1 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                        {pkg.ideal}
                      </span>
                    </div>
                  </div>
                  <svg
                    className={`w-6 h-6 text-gray-400 transition-transform ${
                      expandedPackage === pkg.id ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {expandedPackage === pkg.id && (
                  <div className="px-6 pb-6 border-t border-gray-100">
                    <p className="text-gray-700 text-lg mb-6 mt-4 italic">
                      {pkg.description}
                    </p>

                    {/* Problems and Deliverables Side by Side */}
                    <div className="grid md:grid-cols-2 gap-6 mb-8">
                      {/* Problems Section */}
                      {pkg.problems.length > 0 && (
                        <div>
                          <h4 className="font-semibold text-xl text-gray-800 mb-4 flex items-center">
                            <span className="text-red-500 mr-2">⚠️</span>
                            Problems We Solve
                          </h4>
                          <div className="grid grid-cols-1 mb-4">
                            {pkg.problems.map((problem, idx) => (
                              <div
                                key={idx}
                                className="bg-white p-2
                 text-red-400 text-base"
                              >
                                {problem}
                              </div>
                            ))}
                          </div>
                          {/* Outcome */}
                          <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded">
                            <h4 className="font-semibold text-green-800 text-lg mb-3 flex items-center">
                              <span className="mr-2">✓</span>
                              Outcome
                            </h4>
                            <p className="text-green-700 text-xl">
                              {pkg.outcome}
                            </p>
                          </div>
                        </div>
                      )}

                      {/* Deliverables Section */}
                      <div>
                        <h4 className="font-semibold text-xl text-gray-800 mb-4 flex items-center">
                          <span className="text-blue-500 mr-2">📦</span>
                          What We Deliver
                        </h4>
                        <div className="space-y-4">
                          {pkg.deliverables.map((deliverable, idx) => (
                            <div
                              key={idx}
                              className="border border-green-100 rounded-lg p-4"
                            >
                              <h5 className="font-semibold text-lg text-gray-800 mb-2">
                                {deliverable.title}
                              </h5>
                              <div
                                className="grid grid-cols-1 sm:grid-cols-2 
                              "
                              >
                                {deliverable.items.map((item, itemIdx) => (
                                  <div
                                    key={itemIdx}
                                    className="bg-white p-2
                 text-green-400 text-sm font-medium"
                                  >
                                    {item}
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Company Section */}
      {activeTab === "company" && (
        <section className="max-w-7xl mx-auto sm:p-6 lg:p-8 ">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-12">
            <div className="grid md:grid-cols-2 gap-8 p-3 md:p-6 items-center">
              <div>
                <Heading
                  level={1}
                  className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 leading-tight"
                >
                  Welcome to HR Labs,
                  <br />
                  where human-centered HR consulting
                  <br />
                  meets transformative solutions.
                </Heading>
                <div className="space-y-4">
                  <Paragraph className="text-lg text-gray-700">
                    <li>
                      At HR Labs, we believe that people are the heart of every
                      organization.
                    </li>
                  </Paragraph>
                  <Paragraph className="text-lg text-gray-700">
                    <li>
                      That's why we're dedicated to providing personalized HR
                      consulting services that empower businesses to thrive and
                      grow.
                    </li>
                  </Paragraph>
                </div>
              </div>
              <div className="flex items-center justify-center">
                <img
                  src={Images4}
                  alt="HR Labs Consulting"
                  className="w-full max-h-96 object-contain rounded-lg "
                />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-2 gap-8 p-5 md:p-9 items-center">
              <div className="flex items-center justify-center order-2 md:order-1">
                <img
                  src={Images5}
                  alt="HR Labs Team"
                  className="w-full max-h-64 object-contain rounded-lg"
                />
              </div>
              <div className="space-y-4 order-1 md:order-2">
                <Paragraph className="text-lg text-gray-700">
                  <li>
                    With a focus on humanizing the workplace experience, we
                    tailor our solutions to meet the unique needs and challenges
                    of each client.
                  </li>
                </Paragraph>
                <Paragraph className="text-lg text-gray-700">
                  <li>
                    At HR Labs, we're more than just consultants –{" "}
                    <span style={{ color: "#0086D3", fontWeight: "600" }}>
                      we're partners on your journey to success.
                    </span>
                    <br />
                    Let us help you unlock the full potential of your most
                    valuable asset – your people.
                  </li>
                </Paragraph>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Products;
